import { Link, useLocation } from 'react-router-dom';

export default function Breadcrumb() {
  const { pathname } = useLocation();

  // Convert slug → Capitalized
  const formatSegment = (text) => text.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  // Split URL path
  const parts = pathname.split('/').filter(Boolean);

  // Generate each crumb
  const breadcrumbItems = parts.map((segment, index) => {
    const path = '/' + parts.slice(0, index + 1).join('/');
    return {
      name: formatSegment(segment),
      path,
      isLast: index === parts.length - 1,
    };
  });

  return (
    <nav className="text-white/95 text-xs md:text-sm mb-3 flex flex-wrap gap-1 w-10/12 lg:w-1/2">
      {/* Home */}
      <Link to="/" className="hover:text-white">
        Beranda
      </Link>

      {/* Other segments */}
      {breadcrumbItems.map((item, idx) => (
        <span key={idx} className="flex gap-1">
          <span>/</span>
          {item.isLast ? (
            <span className="text-white line-clamp-1">{item.name}</span>
          ) : (
            <span className="text-white/50 line-clamp-1">{item.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
